import { render, staticRenderFns } from "./AutocompleteStudent.vue?vue&type=template&id=4a15cfde&"
import script from "./AutocompleteStudent.vue?vue&type=script&lang=js&"
export * from "./AutocompleteStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemContent})
